import { Colors } from "@daytrip/horizon-util-ts-tokens";
import styled, { css } from "styled-components";

import { Dimensions } from "../Dimensions";
import { Input } from "../input/Input";
import { transformPixelsToRem } from "../utils/transformers/transformPixelsToRem";

export const DropdownWrapper = styled.div<{ spacing?: Dimensions }>`
    position: relative;
    height: ${Dimensions.d48};
    outline: none;
    margin-bottom: ${({ spacing }) => spacing};
`;

export const StyledInput = styled(Input)<{ isOpen: boolean; isPlacePredictionsLoading?: boolean; isValid?: boolean }>`
    ${({ isOpen, isPlacePredictionsLoading }) =>
        isOpen &&
        !isPlacePredictionsLoading &&
        css`
            border-bottom-left-radius: 0;
            border-bottom-right-radius: 0;
        `};

    ${({ isOpen, isValid }) =>
        isOpen &&
        css`
            border-color: ${isValid === false ? Colors.Red400 : Colors.Blue400} !important;
        `}

    ${({ isValid }) => css`
        &:focus::not(:placeholder-shown) {
            border-color: ${isValid === false ? Colors.Red400 : Colors.Blue400} !important;
        }
    `};
`;

export const DropdownBody = styled.div<{ isValid?: boolean }>`
    position: absolute;
    top: calc(100% - 2px);
    left: 0;
    right: 0;
    background: white;
    border-radius: 0 0 ${transformPixelsToRem(5)} ${transformPixelsToRem(5)};
    border-width: 1px;
    border-style: solid;
    border-color: ${Colors.Blue400};
    border-top-color: ${Colors.Grey200} !important;
    overflow-y: auto;
    overflow-x: hidden;
    z-index: 25;

    & > * {
        cursor: pointer;
    }

    ${({ isValid }) =>
        isValid === false &&
        css`
            border-color: ${Colors.Red400};
        `}
`;

export const AddressContainer = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
`;

export const AddressLabel = styled.span`
    flex-grow: 1;
`;

export const PoweredByGoogle = styled.div`
    display: flex;
    align-self: center;
    justify-content: flex-end;
    margin: ${Dimensions.d4};
    margin-left: auto;
    pointer-events: none;

    img {
        width: 144px;
        height: 18px;
    }
`;
